var _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 49,
    viewBox: "0 0 104 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2465 20.9506C36.4652 18.0345 34.7435 15.4578 32.3484 13.62C29.9534 11.7823 27.0189 10.7861 24 10.7861C20.9811 10.7861 18.0466 11.7823 15.6515 13.62C13.2565 15.4578 11.5347 18.0345 10.7534 20.9506L14.7274 22.0154C15.2743 19.9742 16.4795 18.1705 18.156 16.884C19.8326 15.5976 21.8868 14.9003 24 14.9003C26.1132 14.9003 28.1674 15.5976 29.8439 16.884C31.5204 18.1705 32.7256 19.9742 33.2726 22.0154L37.2465 20.9506Z",
    fill: "#26DDF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7535 28.0333C11.5348 30.9493 13.2565 33.526 15.6516 35.3638C18.0466 37.2016 20.9811 38.1977 24 38.1977C27.0189 38.1977 29.9534 37.2016 32.3485 35.3638C34.7435 33.526 36.4652 30.9493 37.2466 28.0333L33.2726 26.9685C32.7257 29.0097 31.5205 30.8134 29.844 32.0998C28.1674 33.3863 26.1132 34.0836 24 34.0836C21.8868 34.0836 19.8326 33.3863 18.1561 32.0998C16.4796 30.8134 15.2744 29.0097 14.7274 26.9685L10.7535 28.0333Z",
    fill: "#26DDF9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.5145,
    y: 22.4871,
    width: 10.9711,
    height: 4.11416,
    fill: "#26DDF9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9429,
    y: 6.67196,
    width: 4.11416,
    height: 35.656,
    fill: "#26DDF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8535 15.1585C61.2313 15.1585 62.4438 15.434 63.4909 15.9576C64.538 16.4812 65.3647 17.2252 65.9434 18.1897C66.5221 19.1817 66.8252 20.3115 66.8252 21.5791C66.8252 22.8742 66.5221 24.004 65.9434 24.9685C65.3647 25.9329 64.538 26.6769 63.4909 27.2005C62.4438 27.7241 61.2313 27.9721 59.8535 27.9721H56.1334V34.4478H52V15.1585H59.8535ZM56.1334 24.5276H59.4677C60.4322 24.5276 61.2037 24.2796 61.7824 23.7284C62.3335 23.2049 62.6367 22.4884 62.6367 21.5791C62.6367 20.6697 62.3335 19.9532 61.7824 19.4021C61.2037 18.8786 60.4322 18.603 59.4677 18.603H56.1334V24.5276Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3935 15.0207C72.8068 15.434 73.0273 15.9576 73.0273 16.5638C73.0273 17.1976 72.8068 17.7212 72.3935 18.1345C71.9526 18.5754 71.429 18.7683 70.7952 18.7683C70.1339 18.7683 69.6103 18.5754 69.1694 18.1345C68.7285 17.7212 68.5356 17.1976 68.5356 16.5638C68.5356 15.9576 68.7285 15.434 69.1694 15.0207C69.6103 14.6074 70.1339 14.3869 70.7952 14.3869C71.429 14.3869 71.9526 14.6074 72.3935 15.0207ZM68.8387 20.2839H72.7241V34.4478H68.8387V20.2839Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4317 15.1585H79.3171V26.3187L84.8835 20.2839H89.2374L84.1946 25.8227L89.5129 34.4478H85.0213L81.439 28.7161L79.3171 31.0032V34.4478H75.4317V15.1585Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104 20.2839V34.4478H100.556L100.197 32.7393C99.7014 33.3455 99.1227 33.7864 98.4613 34.1171C97.8 34.4478 96.9733 34.6131 96.0364 34.6131C94.383 34.6131 93.0328 34.1171 91.9856 33.0975C90.9385 32.0779 90.4149 30.3695 90.4149 27.9721V20.2839H94.3004V27.5036C94.3004 28.7988 94.5208 29.7632 94.9617 30.4246C95.4026 31.0859 96.1191 31.389 97.056 31.389C98.0204 31.389 98.7644 31.0308 99.3156 30.3143C99.8391 29.5979 100.115 28.5783 100.115 27.2556V20.2839H104Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderlogo);
export default __webpack_public_path__ + "static/media/Headerlogo.a8bbacbfe289f958aaead2a06a787751.svg";
export { ForwardRef as ReactComponent };